import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields, Checkbox } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ParamsEficienciaEAD;
export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class EficienciaEAD extends React.PureComponent<{},State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {
                MostrarResumen: true, 
                MostrarMatriz: true,
                MostrarCalculosPorSucursal:true,
                MostrarCantidadGuiasPorSucursal: true 
            } as Entity
        };
    }

    errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            FechaDesde: validation.required,
            FechaHasta: validation.required
        };
    }

    onGenerarEficienciaEAD = async () => {
        const guiasDoc = await resources.RepEficienciaEAD.Generar(this.state.value);
        await kea.download(guiasDoc, "Reporte eficiencia EAD.xls");
    }

    render() {
        const getField = this.getField;
        const Check = getField(kea.Checkbox);
        const DateTime = getField(kea.DateTime);
        const Sucursal = getField(selectores.Sucursal);
        return (
            <div>
                <kea.Title titulo="Reporte de eficiencia EAD" onRegresar={() => history.go("../")} />
                <DateTime field="FechaDesde" label="Fecha desde" />,
                <DateTime field="FechaHasta" label="Fecha hasta" />,
                <Sucursal field="IdSucursal" label="Sucursal" />,
                <Check field="MostrarResumen" label="Mostrar resumen" readonly={true} />,
                <Check field="MostrarMatriz" label="Mostrar,matriz de tiempos" />,
                <Check field="MostrarCantidadGuiasPorSucursal" label="Mostrar guías EAD por sucursal" />,
                <Check field="MostrarCalculosPorSucursal" label="Mostrar tabla de cálculos por sucursal" />
                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={this.onGenerarEficienciaEAD} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteeficienciaead/index.tsx